export const REPORTS_FEATURE = "reports";
export const COMPARE_FEATURE = "compare";
export const EDIT_FEATURE = "edit";
export const DEPLOY_TO_PROD = "deploy_to_prod";
export const FLASH_INSIGHTS = "flash_insights";
export const WIFI_OCCUPANCY = "wifi_occupancy";
export const TIMEBAR_DRAG = "timebar_drag";
